<template>
  <div class="vtoSnackbar">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VtoSnackbar',
};
</script>
